import React from "react";

function ButtonSpinLoader({ isLoading, isColor }) {
  return (
    <div
      className={`${isLoading ? "spinner-border mx-2" : ""}`}
      style={{ color: isColor }}
    />
  );
}

export default ButtonSpinLoader;
